import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { themeConfig, useThemeContext } from '@/shared/theme';
import { Col } from '@/shared/ui';
import { PageLayout } from '@/widgets/page-layout';

export const RegisterSuccess = () => {
  const { theme } = useThemeContext();
  const navigate = useNavigate();

  return (
    <PageLayout
      contentStyle={{
        padding: 0,
        background: '#fff',
        overflowY: 'auto',
      }}
    >
      <Col justifyContent="center" style={{ minHeight: '100vh' }}>
        <Result
          status="success"
          title="Check your mailbox for confirmation link."
          subTitle={
            <span style={{ color: themeConfig[theme].colors.text }}>
              Your account has been successfully created. Please check your
              mailbox for confirmation link.
            </span>
          }
          extra={[
            <Button key="login" onClick={() => navigate('/')}>
              Go home
            </Button>,
          ]}
        />
      </Col>
    </PageLayout>
  );
};
